import { ErrorBoundary } from 'react-error-boundary'
import { useRouter } from 'next/router'

import { KinerjaErrorBoundary } from 'app/KinerjaShared/components/KinerjaErrorBoundary'
import KinerjaLayoutBase from 'app/KinerjaShared/components/KinerjaLayoutBase'
import { RoleContentProvider } from 'app/KinerjaShared/components/RoleContentProvider'
import { ToggleSdkContext } from 'utils/useToogleSdk'
import DemoModeProvider from './DemoModeProvider'
import { PageHeader } from './DemoPageHeader'
import PeriodProvider from 'app/KinerjaShared/components/PeriodProvider'

import type { KinerjaLayoutProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { FC } from 'react'
import type { FallbackProps } from 'react-error-boundary'

const title = 'Pengelolaan Kinerja'

export const KinerjaDemoLayout: FC<KinerjaLayoutProps> = (props) => {
  const { asPath } = useRouter()

  return (
    <ErrorBoundary
      resetKeys={[asPath]}
      FallbackComponent={(errorProps: FallbackProps) => (
        <KinerjaErrorBoundary
          {...errorProps}
          layoutProps={{ title, ...props }}
        />
      )}
    >
      <ToggleSdkContext.Provider value={props?.pageProps?.toggle}>
        <RoleContentProvider
          disableLoading // Prevent loading spinner to take over the screen when loading the user profile
        >
          <PeriodProvider>
            <KinerjaLayoutBase title={title} {...props} hasHeader={false}>
              <DemoModeProvider isDemoMode={true}>
                <PageHeader title="Pengelolaan Kinerja" />
                {props.children}
              </DemoModeProvider>
            </KinerjaLayoutBase>
          </PeriodProvider>
        </RoleContentProvider>
      </ToggleSdkContext.Provider>
    </ErrorBoundary>
  )
}

export default KinerjaDemoLayout
